import {Alert, Button, Form, Icon, Modal, notification, Spin, Table} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'redux-scaffolding-ts';
import {formatMessage} from '../../../../core/services/http.service';
import {NewTaskTemplateItem, NewTaskTemplateStore} from '../../../../stores/templates-store';
import TaskTemplateFormBody from './task-template-form-body';


let nextId = 1
let FormItem = Form.Item
interface NewTaskTemplateViewProps {
    companyId: string,
    onClose: (id: string | undefined, item?: NewTaskTemplateItem) => void;
    onOk?: (id: string | undefined) => void
    columns?: any[]
    companyAllowCir: boolean,
    companyAllowCii: boolean,
}

interface NewTaskTemplateViewState {
    isCreationModalOpen: boolean,
    templates: any[],
    data: any[],
    isBusy?: boolean
}


@connect(["newProjectTaskStore", NewTaskTemplateStore])
class NewTaskTemplateView extends React.Component<NewTaskTemplateViewProps & WithTranslation & FormComponentProps, NewTaskTemplateViewState> {
    private get NewTaskTemplateStore() {
        return (this.props as any).newProjectTaskStore as NewTaskTemplateStore;
    }

    constructor(props: NewTaskTemplateViewProps & WithTranslation & FormComponentProps) {
        super(props);
        
        this.NewTaskTemplateStore.createNew({} as any);
        const keys = this.props.form.getFieldValue('keys')
        this.props.form.setFieldsValue({
            keys: [0]
        })
        this.state = {
            templates: [],
            isCreationModalOpen: false,
            data: [],
            isBusy:false
        }
    }
    private columns = [
        
        {
            title: this.props.t('Name'),
            dataIndex: 'name',
        },
        {
            title: '',
            key: 'action',
            width: '50px',
            render: (text:any, record:any, index:number) => (
                <Button type="danger" onClick={() => this.delete(index)} size="small" >
                    <Icon
                        type="delete"
                        style={{ color: 'white' }}
                    />
                </Button>
            ),
          },

      ];


    addTaskItem = () => {
        const { form } = this.props
        const keys = form.getFieldValue('keys')
        const nextKeys = keys.concat(nextId++)
        form.setFieldsValue({
            keys: nextKeys
        })
    }
    openCreateTask = () => {
        this.setState({ isCreationModalOpen: true })
    }

    @autobind
    componentWillMount() {
        this.NewTaskTemplateStore.changeUrl(this.props.companyId)
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private async onCreateNewItem() {
        if (this.state.templates.length == 0) {
            this.onCancelNewItem()
            return
        }

        this.setState({ isBusy:true })
        const { t } = this.props;
        const { getFieldDecorator, getFieldValue } = this.props.form
        getFieldDecorator('keys', { initialValue: [] })

        this.NewTaskTemplateStore.clearErrorMessages()
        let templates = [...this.state.templates]
        var successCount = 0
        for (var i = 0; i < templates.length; i++) {
            let taskTemplates = templates[i] as Partial<NewTaskTemplateItem> | undefined
            this.NewTaskTemplateStore.clear()
            this.NewTaskTemplateStore.change(taskTemplates);

            try {
                let result = await this.NewTaskTemplateStore.post()
                if (this.props.onOk) this.props.onOk(result.identifier)
                if (result.isSuccess) {
                    successCount++
                    this.countDownNotification(notification.success, t("Success"), t("Operation completed successfully"), "success");
                } else {
                    this.countDownNotification(notification.error, t("Error"), t("There was an error"), "failure");
                }
            } catch (e) {
            }
        }

        if (successCount == templates.length) {
            this.NewTaskTemplateStore.clearErrorMessages()
            this.props.onClose((this.NewTaskTemplateStore.state.result as any).aggregateRootId, this.NewTaskTemplateStore.state.item)
        } else {
        }

        this.setState({ isBusy: false })
    }

    @autobind
    private onAddTask(reset:any) {
        const { t } = this.props;
        this.NewTaskTemplateStore.clearErrorMessages()

        this.props.form.validateFields(event => {
            var values = this.props.form.getFieldsValue();
            if (!event) {
                values = { ...values, companyId: this.props.companyId };
                const newdata = {
                    key: this.state.templates.length + 1 ,
                    name: values.title
                }
                const newTemplate = {
                    title: values.title,
                    reference: values.reference,
                    companyId: this.props.companyId,
                    sticky: values.sticky,
                    cirEligibility: values.cirEligibility,
                    ciiEligibility: values.ciiEligibility,
                    projectTemplates: values.projectTemplates
                } as NewTaskTemplateItem
                this.setState({ templates: [...this.state.templates, newTemplate], isCreationModalOpen: false, data: [...this.state.data, newdata] },reset())
            }
        });

    }

    @autobind
    private onCancelNewItem() {
        this.NewTaskTemplateStore.clearErrorMessages()
        this.NewTaskTemplateStore.clear();
        this.props.onClose(undefined);
    }
    
    private delete = (index: number) => {
        var dataCopy = [...this.state.data]
        var templatesCopy = [...this.state.templates]
        dataCopy.splice(index, 1)
        templatesCopy.splice(index, 1)
        this.setState({ data: dataCopy, templates: templatesCopy })
    }

    public render() {
        const { getFieldDecorator, resetFields } = this.props.form;
        const { t } = this.props;
        
        const body = (
            <TaskTemplateFormBody
                companyId={this.props.companyId}
                i18n={this.props.i18n}
                t={this.props.t}
                tReady={this.props.tReady}
                item={this.NewTaskTemplateStore.state.item}
                getFieldDecorator={getFieldDecorator}
                resetfields={resetFields}
                onAddTask={this.onAddTask}
                companyAllowCir={this.props.companyAllowCir}
                companyAllowCii={this.props.companyAllowCii}
            />)

        return (
            <div>
                {
                    !this.state.isCreationModalOpen &&
                    < Modal
                        visible
                        title={t("Task templates")}
                        onCancel={this.onCancelNewItem}
                        onOk={this.onCreateNewItem}
                        width='800px'
                        okText={t("OK")}
                        cancelText={t("Cancel")}
                        closable={false}>
                        {this.NewTaskTemplateStore.errorMessages.length > 0 && 
                            <Alert type='error'
                            message={t("Error")}
                            description={(<ul>
                                {this.NewTaskTemplateStore.errorMessages.map(error => {
                                    return <li>
                                        {`${error.title}: ${t(formatMessage(error.message))}`}
                                    </li>
                                    })}
                            </ul>)}
                        />}

                        <Spin spinning={this.NewTaskTemplateStore.state.isBusy || this.state.isBusy}>
                            <Form
                                onKeyUp={(e) => { if (e.keyCode === 13) { this.onAddTask(resetFields); } }}
                                id="taskTemplateForm"
                                onSubmit={() => this.onAddTask(resetFields)}>
                                {body}
                            </Form>
                            <Table
                                scroll={{ y: 240 }}
                                tableLayout='fixed'
                                columns={this.columns}
                                dataSource={this.state.data}/>
                        </Spin>
                    </Modal>
                }
            </div>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewTaskTemplateView as any) as any) as any as React.ComponentClass<NewTaskTemplateViewProps>;